import { render } from "./WechatVerification.vue?vue&type=template&id=3c12d55a&scoped=true&ts=true"
import script from "./WechatVerification.vue?vue&type=script&lang=ts"
export * from "./WechatVerification.vue?vue&type=script&lang=ts"

import "./WechatVerification.vue?vue&type=style&index=0&id=3c12d55a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c12d55a"]])